import { Fragment, type ComponentProps, type ReactNode } from 'react';

import { cn } from '../lib/cn';

const SIZE_CLASS = { xs: 'text-xs', sm: 'text-sm' } as const;

/**
 * 인라인 메타 한 줄 — "날짜 · 사람 · 상태".
 * 구분자는 스크린리더가 "가운뎃점"으로 읽지 않도록 `aria-hidden` span에 둔다.
 */
export interface MetaLineProps extends ComponentProps<'p'> {
  /** `null` · `false` · `''` 항목은 건너뛴다. */
  items: ReadonlyArray<ReactNode>;
  /** @default 'xs' */
  size?: 'xs' | 'sm';
}

export function MetaLine({ items, size = 'xs', className, ...props }: MetaLineProps) {
  const visible = items.filter(
    (item): item is Exclude<ReactNode, null | undefined | false | ''> =>
      item !== null && item !== undefined && item !== false && item !== '',
  );

  return (
    <p
      className={cn(
        'text-ink-muted gap-tight flex flex-wrap items-center',
        SIZE_CLASS[size],
        className,
      )}
      {...props}
    >
      {visible.map((item, index) => (
        <Fragment key={typeof item === 'string' || typeof item === 'number' ? item : index}>
          {index > 0 ? <span aria-hidden="true">·</span> : null}
          <span>{item}</span>
        </Fragment>
      ))}
    </p>
  );
}
